import { makeAutoObservable, makeObservable, observable, computed } from "mobx"

import { pickRandom } from "../utils"
import { STATES } from "./ActivityPedaInstance"

import Notifications from "../Notifications/Notifications"
import ActivityPedaInstance from "./ActivityPedaInstance"
import ActivityResult from "./ActivityResult"
import { TYPES } from "./ActivitiesConverter"

export class Proposition {
  ID
  Text
  target
  placed = null
  placedTS = null

  locked = false
  constructor(json) {
    Object.assign(this, json)
    makeObservable(this, {
      Text: observable,
      target: observable,
      placed: observable,
      placedTS: observable,
      locked: observable,
    })
  }

  get correct() {
    return this.placed && this.placed === this.target
  }

  getCorrectionState(targetId) {

    if(!this.correct && targetId === this.target) return STATES.MISSED
    if(this.correct) return STATES.CORRECT

    return STATES.WRONG

  }
}

export class Target {
  ID
  Text
  config
  constructor(json) {
    Object.assign(this, json)

    makeObservable(this, {
      ID: observable,
      Text: observable,
      config: observable
    })
  }

  setConfig(key, value) {
    if(this.config === undefined) this.config = {}
    this.config = {...this.config, [key]: value}
  }
}


export class DragDrop extends ActivityPedaInstance  {
  ID
  Text = ""
  /** @type {Array<Proposition>} */
  propositions = []
  /** @type {Array<Target>} */
  targets = []

  constructor(json) {
    super()
    Object.assign(this, json)

    this.Type = TYPES.DRAGDROP
  }

  // si on l'utilise direct depuis le json bien formaté
  fromJson(json) {
    Object.assign(this, json)

    /** @type {Array<Proposition>} */
    this.propositions = this.propositions.map(p => new Proposition(p))
    this.targets = this.targets.map(t => new Target(t))
    this.observe()
    return this
  }


  setText(text) {
    this.Text = text
  }

  addProposition(json) {
    this.propositions.push(new Proposition(json))
  }

  getProposition(id) {
    return this.propositions.find(p => p.ID === id)
  }

  addTarget(json) {
    this.targets.push(new Target(json))
  }
  getTarget(id) {
    return this.targets.find(t => t.ID === id)
  }

  get remainingPropositions() {
    return this.propositions.filter(p => !p.placed)

  }

  get placed() {
    return this.propositions.filter(p => p.placed)
  }

  get jokerAvailable() {
    return true
  }


  get allPlaced() {
    return this.propositions.every(p => p.placed)
  }

  localCorrect() {

    let result = this.localCorrectNoResult()

    this.setResult(result)
  }

  localCorrectNoResult() {
    let res = 0;
		let total = this.propositions.length
    this.propositions.forEach(p => {
      if(p.correct) res++
    })

    let result = new ActivityResult()
    result.is_correct = this.propositions.every(p => p.correct )
    result.normalized_score = res/total

    return result
  }

  getAnswer() {
    return this.propositions.map(p => ({ID: p.ID, placedOn: p.placed}))
  }

  place(proposition_id, target_id) {

    let proposition = this.propositions.find(p => p.ID === proposition_id)

    if(proposition) {
      proposition.placed = target_id
      proposition.placedTS = new Date().getTime()

    }

  }


  getSortedPropositionsByTarget(target) {
    return [...this.propositions]
    .sort((p1, p2) => {
      if(p1.placedTS < p2.placedTS) return 1
      if(p1.placedTS > p2.placedTS) return -1
      return 0
    })
    .filter(p => p.target===target.ID)
  }
  getSortedPlacedPropositionsByTarget(target) {
    return [...this.propositions]
    .toSorted((p1, p2) => {
      if(p1.placedTS < p2.placedTS) return 1
      if(p1.placedTS > p2.placedTS) return -1
      return 0
    })
    .filter(p => p.placed===target.ID)

  }

  useJoker() {
    if(!this.jokerAvailable) return

    let elem = null;
    // ici, on chope un élément dans le pool
    if(this.remainingPropositions.length > 0) {
      elem = this.remainingPropositions[0]
    }
    else {
      // si y'en a plus, on chope un placé mais mal placé
      elem = this.placed.find(p => !p.correct)
    }

    if(!elem) {
      // si tout est placé ET bien placé, on en confirme un au pif
      elem = pickRandom(this.placed)
    }

    this.place(elem.ID, elem.target)
    elem.locked = true



    this.jokerUsed = true


  }

  handleJauges(jauges) {
    // on regarde les propales placées

    this.propositions
    .forEach(p => {
      // si elles ont une info de jauge

      if(p.jauge) {
        try {
          let jauge_obj = JSON.parse(p.jauge)

          Object.keys(jauge_obj).forEach(jauge_id => {

            let values = jauge_obj[jauge_id]
            let value = p.correct ? values[0] : values[1]
            value = value || 0

            let success = jauges.increment(jauge_id, value)
            if(!success) Notifications.error("Erreur colonne 'jauge' pour le DRAGDROP " + this.ID + " : cette id de jauge n'existe pas dans 'jauge.data' : " + jauge_id)

          })

        }
        catch(err) {
          Notifications.error("Erreur colonne 'jauge' pour le DRAGDROP " + this.ID)
          console.log("err", err)
        }
      }

    })

  }

  getState() {
    let state = super.getState()
    state.propositions = this.propositions.map(p => { return { placed : p.placed, placedTS : p.placedTS } })

    return state
  }
  /**
   * Permet de remettre l'activité dans un état donné.
   * L'idée est de pouvoir reprendre l'activité dans un état bien précis via la sauvegarde ou autre chose, donc ça doit être
   * cohérent avec le fonctionnement de getState()
   */
  setState(state) {
    super.setState(state)
    state.propositions.forEach((p, index) => {
      let prop = this.propositions[index]
      if (prop) {
        prop.placed = p.placed
        prop.placedTS = p.placedTS
      }
    })
  }


  reset() {
    this.setResult(null)
    this.propositions.forEach(p =>{
      p.placed = null
      p.placedTS = null
    })
  }

  observe() {
    super.observe()
    makeObservable(this, {
      propositions: observable,
      targets: observable,
      remainingPropositions: computed
    })
  }


}

export class DragDropFile {

  /** @type {DragDrop} */
  all = []

  constructor(json, file) {

    /** @type {DragDrop} */
    let current = null
    json.forEach(row => {
      try {
        if(row.Type === TYPES.DRAGDROP || row.Type === "title" || row.Type === "dragdrop") {
          current = this.makeDragDrop(row)
          this.all.push(current)
        }

        if(row.Type === "proposition") {
          current.addProposition(row)
        }

        if(row.Type === "target") {
          current.addTarget(row)
        }

        if(row.Type === "debrief") {
          current.addDebrief(row, null)
        }
        if(row.Type === "debrief_correct") {
          current.addDebrief(row, true)
        }
        if(row.Type === "debrief_incorrect") {
          current.addDebrief(row, false)
        }
      }
      catch(err) {
        throw "ERREUR CREATION DRAG DROP : " + row.ID + " dans " + file
      }
    })
  }

  makeDragDrop(row) {
    return new DragDrop(row)
  }

  observeAll() {
    this.all.forEach(dd => dd.observe())
  }
  get(id) {
    return this.all.find(gd => gd.ID === id)
  }


  /**
   *
   * @param {DragDrop} dragdrop
   * @returns {Array}
   */
  static toDataRows(dragdrop) {
    // ici on voudrait générer les lignes pour le dragdrop
    let rows = []

    // ligne de question
    rows.push({
      ID: dragdrop.ID,
      Type: TYPES.DRAGDROP,
      Text: dragdrop.Text,
      media: dragdrop.media
    })


    // lignes de targets
    dragdrop.targets.forEach(t => {
      rows.push({
        ID: t.ID,
        Type: "target",
        Text: t.Text,
        media: t.media,
      })
    })

    // lignes de targets
    dragdrop.propositions.forEach(p => {
      rows.push({
        ID: p.ID,
        Type: "proposition",
        Text: p.Text,
        target: p.target,
        media: p.media,
      })
    })

    // lignes de debriefs
    dragdrop.debriefs.forEach(d => {
      rows.push({
        ID: d.ID,
        Type: "debrief",
        Text: d.Text,
        media: d.media,
        isCorrect: d.isCorrect
      })
    })

    return rows
  }
}
